import React, { useState, useEffect, useRef } from 'react';
import { ChevronRight, BoxArrowUpRight } from 'react-bootstrap-icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import GLIFOSService from '../services/Api';
//import { useNavigate } from 'react-router-dom';
import useIsInViewport from '../hooks/useIsInViewport';
import { ISADG_LEVELS } from '../utilities/globals';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const apiService = new GLIFOSService();

export default function TreeView(props) {
	const {
		isadg,
		inViewer,
		selected: propSelected,
		isFather = false,
		root_father,
	} = props;
	const [searchParams, setSearchParams] = useSearchParams();
	const selected = searchParams.get('nav');
	//console.log('selected', props);
	const navigate = useNavigate();
	const [tree, setTree] = useState({ isLoading: false, payload: [] });
	const [collectionInfo, setCollectionInfo] = useState({
		isLoading: true,
		payload: {},
	});
	const [page, setPage] = useState(1);
	const loadMoreRef = useRef(null);
	const isLoadMoreInViewport = useIsInViewport(loadMoreRef.current);
	const [selectedInViewer, setSelectedInViewer] = useState('');

	useEffect(() => {
		if (
			isLoadMoreInViewport &&
			!tree.isLoading &&
			page <
				+collectionInfo.payload?.result_header?.pagination?.total_pages
		)
			setPage((prevPage) => prevPage + 1);
		return () => {
			setPage((prevPage) => prevPage);
		};
	}, [
		isLoadMoreInViewport,
		tree.isLoading,
		page,
		collectionInfo.payload?.result_header?.pagination?.total_pages,
	]);

	useEffect(() => {
		try {
			if (!isadg) return;

			if (isFather && page > 1) return;
			setCollectionInfo((prevData) => ({ ...prevData, isLoading: true }));
			setTree((prevData) => ({ ...prevData, isLoading: true }));
			apiService.getCollectionInfoSolr(
				{
					params: {
						repository: isadg.includes('GT-CIRMA-FG')
							? 'CIRMA-FG'
							: 'CIRMA-AH',
						isadg,
						page,
						sortby: 'codRef',
						sorttype: 'asc',
					},
				},
				{},
				(_, rdata) => {
					//console.log('rdata', rdata);
					setCollectionInfo({ isLoading: false, payload: rdata });
					const collections = rdata?.collections
						? Array.isArray(rdata.collections)
							? rdata.collections
							: [rdata.collections]
						: [];
					/* if (isFather && rdata?.father) {
						console.log('isFather', isFather, rdata);
						setTree((prevData) => ({
							isLoading: false,
							payload: [
								{
									page: 1,
									children: true,
									...rdata.father,
									id: isadg,
								},
							],
						}));
					} */
					setTree((prevData) => ({
						isLoading: false,
						payload: [
							...prevData.payload,
							...collections.map((collection) => ({
								page: 1,
								children: selected?.includes(collection.id),
								...collection,
							})),
						],
					}));
				}
			);
		} catch (e) {
			console.log('error en treeview', e);
			setCollectionInfo((prevData) => ({
				...prevData,
				isLoading: false,
			}));
			setTree((prevData) => ({ ...prevData, isLoading: false }));
		}
		return () => {
			setCollectionInfo({ isLoading: false, payload: [] });
			setTree((prevData) => ({ ...prevData, isLoading: false }));
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isadg, page]);

	function filterGallery(code, loadable, ev, level) {
		/* console.log('CLIIIIIICK',level)
		console.log('CLIIIIIICK',loadable) */
		if (level === 'item') {
			navigate(`/glifos/item/${code}`);
		} else if (level === 'file' && loadable === 0) {
			navigate(`/glifos/item/${code}`);
		} else {
			addChildren(code, loadable);
			!inViewer && selected !== code && setSearchParams({ nav: code });
			inViewer && setSelectedInViewer(code);
			ev.currentTarget.parentNode.parentNode.parentNode.classList.toggle(
				'displayed'
			);
		}
	}

	useEffect(() => {
		const index = tree.payload.findIndex((unit) => unit.id === selected);
		if (
			!tree.payload[index]?.children &&
			tree.payload[index]?.decendents > 0
		)
			setTree((prevTree) => ({
				...prevTree,
				payload: [
					...prevTree.payload.slice(0, index),
					{ ...prevTree.payload[index], children: true },
					...prevTree.payload.slice(index + 1),
				],
			}));
		return () =>
			setTree((prevTree) => ({
				...prevTree,
			}));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selected]);

	useEffect(() => {
		return () => {
			setTree((prevTree) => ({ ...prevTree, isLoading: false }));
		};
	}, []);

	function addChildren(code, loadable) {
		const index = tree.payload.findIndex((unit) => unit.id === code);
		if (!tree.payload[index].children && loadable > 0)
			setTree((prevTree) => ({
				...prevTree,
				payload: [
					...prevTree.payload.slice(0, index),
					{ ...prevTree.payload[index], children: true },
					...prevTree.payload.slice(index + 1),
				],
			}));
	}

	function handleClick(evc) {
		evc.stopPropagation();
		evc.preventDefault();
		evc.currentTarget.parentNode.classList.toggle('displayed');
		const code = evc.currentTarget.dataset.code;
		const loadable = evc.currentTarget.dataset.loadable;
		addChildren(code, loadable);
		inViewer && setSelectedInViewer(code);
	}

	function showTree(level) {
		//console.log(ISADG_LEVELS[level]?.showInTree || isadg.includes('GT-CIRMA-AH'))
		return ISADG_LEVELS[level]?.showInTree || isadg.includes('GT-CIRMA-AH');
	}

	return (
		<div className='gtvcmp'>
			{collectionInfo.isLoading && <div>Loading...</div>}
			{!tree.isLoading && tree.payload.length === 0 && ''}
			{!tree.isLoading &&
				tree.payload.length > 0 &&
				tree.payload.map((unit, index) => {
					const show = showTree(unit?.level);
					if (show) {
						return (
							<div className={'gtvsi'} key={index}>
								<div
									className={
										'ic' +
										(selected?.includes(unit.id) ||
										(inViewer &&
											selectedInViewer?.includes(unit.id))
											? ' displayed selected'
											: '')
									}
								>
									<div
										className='iic'
										onClick={handleClick}
										data-code={unit.id}
										data-loadable={+unit.visibleDecendents}
									>
										{+unit.visibleDecendents > 0 ||
										(unit?.children &&
											isadg.includes('GT-CIRMA-AH')) ? (
											<ChevronRight />
										) : (
											<span> &nbsp; </span>
										)}
									</div>
									<div className='ico'>
										{typeof unit.id !== 'undefined' ? (
											<div className='ibh'>
												<div
													onClick={(ev) => {
														filterGallery(
															unit.id,
															+unit.decendents,
															ev,
															unit?.level
														);
													}}
													className={
														unit.id === selected ||
														unit.id
															? ' selected'
															: ''
													}
												>
													<div className='collectionid'>
														{unit.id}
													</div>
													<div className='colltitle'>
														{unit.title}
													</div>
												</div>
											</div>
										) : (
											' .. empty ..'
										)}
										<div className='ich'>
											<div className='it-rem'>
												{(unit?.children &&
													+unit.visibleDecendents >
														0) ||
												(unit?.children &&
													isadg.includes(
														'GT-CIRMA-AH'
													)) ? (
													<TreeView
														isadg={unit.id}
														inViewer={inViewer}
														selected={propSelected}
														root_father={
															root_father
														}
													/>
												) : (
													<></>
												)}
											</div>
										</div>
									</div>
									{inViewer && (
										<div className='ms-auto d-flex h-100 flex-column justify-content-center align-items-center'>
											<OverlayTrigger
												overlay={
													<Tooltip id={`${unit.id}`}>
														Ir a colección
													</Tooltip>
												}
											>
												<a
													href={
														unit.level === 'item'
															? `/glifos/item/${unit.id}`
															: unit.level ===
																	'file' &&
															  +unit.decendents ===
																	0
															? `/glifos/item/${unit.id}`
															: `/glifos/collection/${root_father}?nav=${unit.id}`
													}
												>
													<BoxArrowUpRight />
												</a>
											</OverlayTrigger>
										</div>
									)}
								</div>
							</div>
						);
					}
				})}
			{page <
				+collectionInfo.payload?.result_header?.pagination
					?.total_pages && (
				<div
					className='d-flex justify-content-center'
					id='loadMore'
					ref={loadMoreRef}
				>
					<div>Loading...</div>
				</div>
			)}

			{/* {unit.payload?.collections?.length > 0 &&
				unit.payload.collections.map((xe, xi) => {
					if (inViewer && !propSelected?.includes(xe.code)) return '';
					return (
						<div className='gtvsi' key={xi}>
							<div
								className={
									'ic' +
									(selected?.includes(xe.code) ||
									(inViewer &&
										propSelected?.includes(xe.code))
										? ' displayed selected'
										: '')
								}>
								<div
									className='iic'
									onClick={handleClick}
									data-code={xe.code}
									data-loadable={xe.loadable}>
									{xe.loadable > 0 ? (
										<ChevronRight />
									) : (
										<span> &nbsp; </span>
									)}
								</div>
								<div className='ico'>
									{typeof xe.code != 'undefined' ? (
										<div className='ibh'>
											{
												/*<Link to={process.env.PUBLIC_URL+"/item/"+xe.code}>
                                                <div>
                                                    <div className="collectionid">{xe.code}</div>
                                                    <div className='colltitle'>{xe.display_name}</div>
                                                </div>
                                            </Link>: * /

												//xe.loadable > 0 && (
												<div
													onClick={(ev) => {
														filterGallery(xe.code);
													}}
													className={
														xe.code === selected
															? ' selected'
															: ''
													}>
													<div className='collectionid'>
														{xe.code}
													</div>
													<div className='colltitle'>
														{xe.display_name}
													</div>
												</div>
												//)
											}
										</div>
									) : (
										' .. empty ..'
									)}
									<div className='ich'>
										{
											<div className='it-rem'>
												{xe.children.length > 0 && (
													<TreeView
														isadg={xe.code}
														inViewer={inViewer}
														selected={propSelected}
													/>
												)}
											</div>
										}
									</div>
								</div>
							</div>
						</div>
					);
				})} */}
		</div>
	);
}
